import { render, staticRenderFns } from "./formHomework.vue?vue&type=template&id=775235d4&"
import script from "./formHomework.vue?vue&type=script&lang=js&"
export * from "./formHomework.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports